module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_library.js
// module id = 53
// module chunks = 0